import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

/* Category value for which Input Voltage Min and Output Voltage Max suitability ranks are disabled */
const LINEAR_CATEGORY = 'Linear';

export class LedDriverAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVinMin = 1.2;
		this.normVinMax = 25;
		this.normIoutMax = 1000;
		this.normVoutMax = 50;

		this.rankVinMin = 0;
		this.rankVinMax = 0;
		this.rankIoutMax = 0;
		this.rankVoutMax = 0;

		this.weightVinMin = 0.1;
		this.weightVinMax = 0.1;
		this.weightIoutMax = 0.2;
		this.weightVoutMax = 0.1;

		this.rVinMin = 0;
		this.rVinMax = 0;
		this.rIoutMax = 0;
		this.rVoutMax = 0;
	}

	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_VinMin,rVinMin,rankVinMin,' +
					'part_VinMax,rVinMax,rankVinMax,' +
					'part_IoutMax,rIoutMax,rankIoutMax,' +
					'part_VoutMax,rVoutMax,rankVoutMax,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		const isLinearCategory = product[CIDS.CATEGORY] === LINEAR_CATEGORY;

		// ---------------------------------------------Input voltage min  VinMin (V) - disabled for Linear Category---------------------------------------------
		if (isLinearCategory) {
			this.rankVinMin = 0;
			this.rVinMin = 0;
			this.rankDebugLog(product, CIDS.V_IN_MIN, this.rVinMin, this.rankVinMin);
		} else {
			[this.rankVinMin, this.rVinMin] = this.calculateRankSingleSliderLTE(CIDS.V_IN_MIN, product, this.normVinMin);
		}

		// ---------------------------------------------Input voltage max  VinMax (V)---------------------------------------------
		[this.rankVinMax, this.rVinMax] = this.calculateRankSingleSliderGTE(CIDS.V_IN_MAX, product, this.normVinMax);

		// ---------------------------------------------Output current  Iout Max (mA)---------------------------------------------
		[this.rankIoutMax, this.rIoutMax] = this.calculateRankSingleSliderGTE(CIDS.I_O_MAX, product, this.normIoutMax);

		// ---------------------------------------------Output voltage max  Vout Max (V) - disabled for Linear Category---------------------------------------------
		if (isLinearCategory) {
			this.rankVoutMax = 0;
			this.rVoutMax = 0;
			this.rankDebugLog(product, CIDS.V_O_MAX, this.rVoutMax, this.rankVoutMax);
		} else {
			[this.rankVoutMax, this.rVoutMax] = this.calculateRankDualSliderGTE(CIDS.V_O_MAX, product, this.normVoutMax);
		}

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightVinMin * this.rankVinMin +
			this.weightVinMax * this.rankVinMax +
			this.weightIoutMax * this.rankIoutMax +
			this.weightVoutMax * this.rankVoutMax;
		let isPunished = false;
		debugLog.push(feRank);

		/* Input Voltage Min and Output Voltage Max are not applicable for Linear Category products,
		 * so they must not be punished for having a null value in those fields. */
		let usedFiltersForPunish = this.usedFilters;
		if (isLinearCategory) {
			usedFiltersForPunish = { ...this.usedFilters };
			delete usedFiltersForPunish[CIDS.V_IN_MIN];
			delete usedFiltersForPunish[CIDS.V_O_MAX];
		}

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, usedFiltersForPunish, feRank);

		let finalRank =
			(1 - this.weightVinMin - this.weightVinMax - this.weightVoutMax - this.weightIoutMax) * super.execute(product) +
			feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
